import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { Intake, Patient } from '../models';
import { Api, Session } from '../services/index';
import { MyModal } from '../components/modal/modal';

@Component({
	selector: 'app-dashboard-medical',
	templateUrl: './dashboard-medical.html',
	styleUrls: ['./dashboard-medical.css']
})

export class DashboardMedicalComponent implements OnInit {
	@ViewChild('myIncompleteProfile') public _modalIncompleteProfile: MyModal;
	@ViewChild('myUCWhatWeTreatModal') public _modalUCWhatWeTreat: MyModal;
	@ViewChild('myBHWhatWeTreatModal') public _modalBHWhatWeTreat: MyModal;
	@ViewChild('myUCProviders') public _modalUUCProviders: MyModal;
	@ViewChild('myBHProviders') public _modalBHProviders: MyModal;
	@ViewChild('myUCWhatToExpectModal') public _modalUCWhatToExpectModal: MyModal;
	@ViewChild('myBHWhatToExpectModal') public _modalBHWhatToExpectModal: MyModal;

	@ViewChild('myUCPricingModal') public _myUCPricingModal: MyModal;
	@ViewChild('myBHPricingModal') public _myBHPricingModal: MyModal;

	@ViewChild('myUCPrescriptionModal') public _myUCPrescriptionModal: MyModal;
	@ViewChild('myBHPrescriptionModal') public _myBHPrescriptionModal: MyModal;


	whatWeTreatUrl = '/dashboard-what-we-treat';
	ourProvidersUrl: string;
	//ourProvidersUrl = '/dashboard-our-providers';
	howItWorksUrl = '/dashboard-how-it-works';
	prescriptionPolicy = '/dashboard-prescription-policy';
	pricingUrl = '/dashboard-pricing';

	avatar: string = '../../assets/images/ico-profile.png';
	isValidProfile: boolean = false;
	loading = false;
	medicalExamType: string;
	patient: Patient;
	title = 'Medical';//'Therapy;
	btnRequestExamText = 'REQUEST A VISIT';
	isBhServiceLine: boolean = false;
	constructor(private api: Api,
		private route: ActivatedRoute,
		private router: Router,
		private service: NotificationsService,
		private sanitizer: DomSanitizer,
		private session: Session) {
		this.medicalExamType = this.route.snapshot.params['type'] || '1';
		this.session.intakeLob = ''
		this.session.intakeBhType = '';
		if(this.medicalExamType === '2'){
			this.session.intakeLob = 'BH'
			this.session.intakeBhType = 'THI';
		}else if(this.medicalExamType === '3'){
			this.session.intakeLob = 'BH'
			this.session.intakeBhType = 'PSI';
		}else{
			this.session.intakeLob = 'UC'
			this.session.intakeBhType = '';
		}
	}

	gotoDashboard() {
		this.router.navigate(['/dashboard']);
	}

	ngOnInit() {
		this.loading = true;
		this.isBhServiceLine = this.session.intakeLob === 'BH';
		this.ourProvidersUrl = '/dashboard-our-providers/' + this.medicalExamType;
		switch (this.medicalExamType) {
			case '1':
				this.whatWeTreatUrl = '/dashboard-what-we-treat';
				this.howItWorksUrl = '/dashboard-how-it-works';
				this.prescriptionPolicy = '/dashboard-prescription-policy';
				this.pricingUrl = '/dashboard-pricing';
				this.title = 'Medical';
				this.btnRequestExamText = 'REQUEST A VISIT';
				break;
			case '2':
				this.whatWeTreatUrl = '/bh-what-we-treat';
				this.howItWorksUrl = '/bh-how-it-works';
				this.prescriptionPolicy = '/bh-prescription-policy';
				this.pricingUrl = '/bh-pricing';
				this.title = 'Therapy';
				this.btnRequestExamText = 'Request a Therapy Session';
				break;
			case '3':
				this.whatWeTreatUrl = '/psychiatry-what-we-treat';
				this.ourProvidersUrl = '/psychiatry-our-providers'
				this.howItWorksUrl = '/psychiatry-how-it-works';
				this.prescriptionPolicy = '/psychiatry-prescription-policy';
				this.pricingUrl = '/psychiatry-pricing';
				this.title = 'Psychiatry';
				this.btnRequestExamText = 'Schedule an Appointment';
				break;
			default:
				this.router.navigate(['/dashboard']);
				break;
		}
		// if (this.medicalExamType === '1') {
		// 	this.whatWeTreatUrl ='/dashboard-what-we-treat';
		// 	this.ourProvidersUrl = '/dashboard-our-providers';
		// 	this.howItWorksUrl = '/dashboard-how-it-works';
		// 	this.prescriptionPolicy = '/dashboard-prescription-policy';
		// 	this.pricingUrl = '/dashboard-pricing';
		// 	this.title = 'Medical';
		// 	this.btnRequestExamText = 'Request a Medical Visit';
		// } else {
		// 	this.whatWeTreatUrl ='/bh-what-we-treat';
		// 	this.ourProvidersUrl = '/bh-our-providers';
		// 	this.howItWorksUrl = '/bh-how-it-works';
		// 	this.prescriptionPolicy = '/bh-prescription-policy';
		// 	this.pricingUrl = '/bh-pricing';
		// 	this.title = 'Therapy';
		// 	this.btnRequestExamText = 'Schedule a Talk Therapy Session';
		// }

		let getPatient = this.api.getMember(this.session.patientId).subscribe(patient => {
			this.patient = patient;
			this.loading = false;
			this.pricingUrl = this.pricingUrl + '/' + this.patient.userId;
			//this.initializePricing(); //need the userid for pricing
		})



	}

	cleanURL(oldURL: string): SafeResourceUrl {
		if (oldURL) {
			return this.sanitizer.bypassSecurityTrustResourceUrl(oldURL);
		}
		return oldURL;
	}

	ucCopay: number = -1;//uc 	urgent care
	bhCopay: number = -1;//bh 	behavioral health
	psiCopay: number = -1;//psi  psych initial
	psfCopay: number = -1;//psf	psych follow up

	showModal(type) {
		if (this.medicalExamType === '1') {
			if (type === 'treat') {
				this._modalUCWhatWeTreat.open();
			} else if (type === 'provider') {
				this._modalUUCProviders.open();
			} else if (type === 'expect') {
				this._modalUCWhatToExpectModal.open();
			}
			else if (type === 'price') {
				this._myUCPricingModal.open();
			}
			else if (type === 'prescription') {
				this._myUCPrescriptionModal.open();
			}

		} else {
			if (type === 'treat') {
				this._modalBHWhatWeTreat.open();
			} else if (type === 'provider') {
				this._modalBHProviders.open();
			} else if (type === 'expect') {
				this._modalBHWhatToExpectModal.open();
			} else if (type === 'price') {
				this._myBHPricingModal.open();
			}
			else if (type === 'prescription') {
				this._myBHPrescriptionModal.open();
			}
		}
	}

	continue(type) {
		if (type === 'uctreat') {
			this._modalUCWhatWeTreat.close();
		} else if (type === 'bhtreat') {
			this._modalBHWhatWeTreat.close();
		} else if (type === 'ucprovider') {
			this._modalUUCProviders.close();
		} else if (type === 'bhprovider') {
			this._modalBHProviders.close();
		} else if (type === 'ucexpect') {
			this._modalUCWhatToExpectModal.close();
		} else if (type === 'bhexpect') {
			this._modalBHWhatToExpectModal.close();
		} else if (type === 'ucprescription') {
			this._myUCPrescriptionModal.close();
		} else if (type === 'bhprescription') {
			this._myBHPrescriptionModal.close();
		}
	}



	gotoWhatWeTreat(){
		this.router.navigate([this.whatWeTreatUrl]);
	}
	gotoPricing(){
		this.router.navigate([this.pricingUrl]);
	}
	gotoHowitworks(){
		this.router.navigate([this.howItWorksUrl]);
	}
	gotoOurproviders(){
		this.router.navigate([this.ourProvidersUrl]);
	}
	gotoRx(){
		this.router.navigate([this.prescriptionPolicy]);
	}
	requestExam() {
		if (this.validatePatientProfile(this.patient)) {
			if (this.medicalExamType === '1') {
				//this._myUCPricingModal.close();
				this.session.intakeLob = 'UC';
				this.router.navigate(['/exam-request-care-today']);
			} else {
				//this._myBHPricingModal.close();
				this.loadExamRequestCareToday();
			}
		} else {
			this._modalIncompleteProfile.open();
		}
	}

	validatePatientProfile(patient): boolean {
		return true;
	}

	gotoProfile(update) {
		if (update) {
			this.router.navigate(['/dashboard-my-profile']);
		}
		this._modalIncompleteProfile.close();
	}

	loadExamRequestCareToday() {
		this.session.intakeLob = 'BH';
		if(this.medicalExamType === '2'){
			this.session.intakeBhType = 'THI';
		}else if(this.medicalExamType === '3'){
			this.session.intakeBhType = 'PSI';
		}
		this.router.navigate(['/exam-request-care-today']);
	}

	initializePricing() {
		this.loading = true;
		let lob = '';
		if (this.medicalExamType === '1') {
			lob = 'uc';
		} else {
			lob = 'bh';
		}
		this.ucCopay = -1;
		this.bhCopay = -1;
		this.psiCopay = -1;
		this.psfCopay = -1;

		this.api.getPatientPlans(this.patient.userId, lob).subscribe(result => {
			console.log('getPatientPlans', result);
			if (result == null || result.length === 0) {
				console.log('defaulting pay rates.');
				this.ucCopay = 57.95;
				this.bhCopay = 80;
				this.psiCopay = 200;
				this.psfCopay = 95;
				this.loading = false;
				return;
			}

			result.forEach(policy => {
				if (policy == null) {
					console.log('policy is null:', policy);
					this.loading = false;
					return;
				}

				console.log('policy.PlanTypeCode:', policy.planTypeCode);
				switch (policy.planTypeCode) {
					case 'UC':
						if (this.ucCopay > policy.coPay || this.ucCopay < 0) {
							this.ucCopay = policy.coPay;
						}
						break;
					case 'BH':
						if (this.bhCopay > policy.coPay || this.bhCopay < 0) {
							this.bhCopay = policy.coPay;
						}
						break;
					case 'PSI':
						if (this.psiCopay > policy.coPay || this.psiCopay < 0) {
							this.psiCopay = policy.coPay;
						}
						break;
					case 'PSF':
						if (this.psfCopay > policy.coPay || this.psfCopay < 0) {
							this.psfCopay = policy.coPay;
						}
						break;
				}

			});

			if (this.ucCopay < 0) { this.ucCopay = 57.95; }
			if (this.bhCopay < 0) { this.bhCopay = 80; }
			if (this.psiCopay < 0) { this.psiCopay = 200; }
			if (this.psfCopay < 0) { this.psfCopay = 95; }
			this.loading = false;
		});
	}


}
